export default {
  USCustomary:
    [
      {
        title: 'Most Likely Cracking DM',
        fileName: 'mostLikelyCrackingDMProb1Example.json',
      },
      {
        title: 'Most Likely Thinning DM',
        fileName: 'mostLikelyThinningDMProb1Example.json',
      },
      {
        title: 'Damage Rate Calculation given Chloride SCC - External DM',
        fileName: 'chlroideSCCExternalProb2Example.json',
      },
      {
        title: 'Damage Rate Calculation given Tank Bottom Corrosion DM',
        fileName: 'tankBottomProb2Example.json',
      },
      {
        title: 'Damage Rate NH4Cl Corrosion - Deliquescence',
        fileName: 'NH4Cl_corrosion_deliquescence.json',
      },
      {
        title: 'Damage Rate NH4Cl Corrosion - Condensation',
        fileName: 'NH4Cl_corrosion_condensation.json',
      },
      {
        title: 'Damage Rate NH4HS Corrosion',
        fileName: 'NH4HS_corrosion.json',
      },
      {
        title: 'Damage Rate CO2 Corrosion',
        fileName: 'CO2_corrosion.json',
      },
      {
        title: 'Damage Rate HCl Corrosion',
        fileName: 'HClCorrosion.json',
      },
      {
        title: 'Damage Rate H2S Corrosion',
        fileName: 'H2S_corrosion.json',
      },
      {
        title: 'Damage Rate Sulfidation - CS - Moderate Temp and Sulfur',
        fileName: 'sulfidationProb2CSModerateInputs.json',
      },
      {
        title: 'Damage Rate Sulfidation - 4-6Cr - H2S - Low Temp',
        fileName: 'sulfidationProb24CrH2S.json',
      },
      {
        title: 'Damage Rate High Temperature H2/H2S - SS',
        fileName: 'High Temperature H2-H2S , SS.json',
      },
      {
        title: 'Damage Rate Naphthenic Acid - CS',
        fileName: 'NAC, CS, OA acid.json',
      },
      {
        title: 'Damage Rate Aqueous Organic Acid Corrosion- Acetic acid- Dynamic Fluid',
        fileName: 'Acetic_acid_Dynamic_Fluid.json',
      },      
      {
        title: 'Damage Rate Aqueous Organic Acid Corrosion- Acetic and Formic Acids- Static Fluid',
        fileName: 'Both_acids_Statics.json',
      },
    ],
  Metric: [],
}
